export default __webpack_public_path__ + "static/media/black-point.39ba6e6b.svg";